import { Card } from '~ui/base/card';
import { Typography } from '~ui/base/typography';
import { datasetsContainer, storageAccount } from '~lib/storage/config';

function DatasetsEmpty() {
  return (
    <Card ornament="outline" className="text-center">
      <Typography variant="headline-sm" as="h2">
        No datasets yet
      </Typography>
      <Typography variant="body-md" as="p" className="mt-3 text-muted-foreground">
        Upload a folder of files to{' '}
        <span className="font-mono">
          {storageAccount}/{datasetsContainer}/&lt;dataset-name&gt;/
        </span>{' '}
        and it will appear here.
      </Typography>
    </Card>
  );
}

export { DatasetsEmpty };
